module.exports = __webpack_public_path__ + "static/media/sendNotificationIcon.b2e3e55a.svg";